export const bn_locale = {
  services_benefits: 'সেবা ও সুবিধা',
  why_gold_kinen: 'কেন গোল্ড কিনেন',
  about_us: 'আমাদের সম্পর্কে',
  how_it_works: 'কিভাবে গোল্ড কিনবেন',
  contact_us: 'যোগাযোগ করুন',
  terms_conditions: 'শর্তাবলী',
  ags_terms_conditions : 'গোল্ড সঞ্চয়ের শর্তাবলী',
  privacy_policy: 'গোপনীয়তা নীতি',
  refund_policy: 'রিফান্ড ও রিটার্ন নীতিমালা',
  delivery_policy_protocol: 'ডেলিভারি নীতি এবং প্রোটোকল',
  faq: 'সচরাচর জিজ্ঞাস্য',
  download_app: 'ডাউনলোড অ্যাপ',
  our_official_partners: 'আমাদের অফিসিয়াল পার্টনার',
  more_faq : "আরো প্রশ্ন",
  // Why Gold Kinen page
  gold_new_feature: 'গোল্ড নিউ ফিউচার',
  why_gold: 'কেন গোল্ড',
  why_gold_description: 'মানুষ এবং স্বর্ণের মাঝে একটি দৃঢ় সম্পর্ক রয়েছে। সম্ভবত অন্য কোন মূল্যবান ধাতু মানবজাতির উপর এতটা প্রভাব ফেলতে পারেনি যা গোল্ড পেরেছে । স্বর্ণ দীর্ঘমেয়াদে তার মূল্য বজায় রেখেছে এবং নিজে সম্পদের একটি বড় ভাণ্ডার হিসাবে স্বীকৃত হয়েছে। বেশিরভাগ মানুষ একমত যে স্বর্ণ বিনিয়োগের বিষয়ে অত্যন্ত সন্তোষজনক কিছু আছে, তা কয়েন বা বার হোক। স্বর্ণের কয়েন বা বার কেনা, তারপরে সঞ্চয় করা এবং প্রতিটি মুদ্রার ওজন পৃথকভাবে অনুভব করার মধ্যে একটি বিশেষ অনুভূতি রয়েছে। ঐতিহাসিকভাবে, গোল্ড বৈশ্বিক অনিশ্চয়তা এবং অর্থনৈতিক চাপের সময়ে মূল্যবান ধাতু হিসাবে বিশ্বের বেশিরভাগ মুদ্রাকে ছাড়িয়ে গেছে। তাই গোল্ডে সঞ্চয় করা, আপনার আর্থিক নিরাপত্তা এবং ভবিষ্যত সুরক্ষিত করার একটি স্থিতিশীল উপায়। অনলাইনে গোল্ডের কয়েন/বার কেনা একটি নিরাপদ বিনিয়োগ হিসাবে বিবেচিত হতে পারে। যা নিজের শখের সংগ্রহ বা প্রিয়জনকে উপহার স্বরূপ দেওয়া যেতে পারে যেকোনো অনুষ্ঠান বা উপলক্ষে। ',
  gold_over_time: 'সময়ের সাথে গোল্ড',
  gold_over_time_description: 'একটি বিনিয়োগ যোগ্য পণ্য হিসাবে, গোল্ডের দাম সাধারণত বৃদ্ধি পায় যখন অন্যান্য বিনিয়োগ পণ্যের মূল্য হ্রাস পায়। গোল্ড সবসময়ই আপনার ফিনান্সিয়াল পোর্টফোলিওকে উন্নত করার জন্য একটি লক্ষ্যণীয় প্রভাব ফেলতে সাহায্য করে। গোল্ডের কয়েন/বার একটি দীর্ঘমেয়াদী সম্পদ হিসাবে একটি শক্তিশালী বিনিয়োগ মাধ্যম এবং ক্রমবর্ধমান মুদ্রাস্ফীতির বিরুদ্ধে একটি শক্তিশালী বাঁধ হয়ে দাঁড়াতে পারে। ',
  why_gold_from_gold_kinen: 'গোল্ড কিনেন থেকে গোল্ড কিনেন',
  why_gold_from_gold_kinen_p1: 'গোল্ড কিনেনে,আমাদের প্রতিজ্ঞা, ব্যায় নয় সঞ্চয়েই আস্থা',
  why_gold_from_gold_kinen_p2: 'আপনার গোল্ড 100% সুরক্ষিত',
  why_gold_from_gold_kinen_p2_description: 'আপনি যে গোল্ড কিনছেন তার আইনি মালিক আপনি । আপনার সম্মতি ব্যতীত কেউ আপনার গোল্ড ব্যবহার বা আপনার ভল্ট থেকে বের করতে পারবে না। ',
  why_gold_from_gold_kinen_p3: 'আপনার গোল্ড থাকবে নিরাপদে',
  why_gold_from_gold_kinen_p3_description: 'আমাদের সাথে আপনি যে গোল্ড কিনবেন তা আমাদের লকার পার্টনারদের সুরক্ষিত ভল্টে সঞ্চয় করা হয়। আপনার গোল্ড সম্পূর্ণ প্রতিস্থাপন মূল্যে সমস্ত ঝুঁকির বিরুদ্ধে সম্পূর্ণরূপে বীমাকৃত।',

  //  Services & Benefits
  services:'সেবা ',
  buy_gold: "গোল্ড ক্রয়",
  buy_gold_description: "সর্বনিম্ন ৫০০ টাকা থেকে শুরু করে গোল্ড ক্রয় এবং সংরক্ষণ শুরু করুন। গোল্ড কিনেন অ্যাপের মাধ্যমে, যেকোনো স্থান থেকে অফিসিয়াল বাজারমূল্যে ২২ ক্যারাট হলমার্ক প্রত্যয়িত গোল্ড ক্রয় করতে পারবেন মুহূর্তেই। ",
  save_gold : "গোল্ড সঞ্চয়",
  save_gold_description: "প্রতি মাসে স্বয়ংক্রিয়ভাবে নির্ধারিত তারিখে গোল্ড সঞ্চয় করুন অটো গোল্ড সেভ প্ল্যানের সাথে। সর্বনিম্ন ১০০০ টাকা থেকে ৫০০০০ টাকা পর্যন্ত, ৩, ৬, এবং ১২ মাস মেয়াদে অটো গোল্ড সেভিং শুরু করুন এবং প্রতি মাসে আপনার নির্ধারিত অর্থের সমপরিমাণ গোল্ড সঞ্চিত হবে আপনার অ্যাকাউন্টে। আপনার সুবিধা অনুযায়ী নিয়মিতভাবে সমৃদ্ধ হবে আপনার গোল্ড সঞ্চয়ের যাত্রা।",
  collect_gold: "গোল্ড উত্তোলন",
  collect_gold_description: "গোল্ড কিনেন অ্যাপে সঞ্চিত গোল্ড, যেকোনো সময় ১, ৫, ও ১০ গ্রামের গোল্ড বার অথবা ২ ও ৪ গ্রামের গোল্ড কয়েন রূপে উত্তোলন করুন সহজেই।  আপনার প্রাপ্য গোল্ড ঢাকা সিটি কর্পোরেশনের অন্তুর্ভুক্ত এলাকায়  সুরক্ষিত ও বীমাকৃত ডেলিভারির মাধ্যমে এবং দেশজুড়ে ১৫০+ নির্বাচিত পিক-আপ পয়েন্টের মাধ্যমে নিরাপদে পৌঁছে দেয়া হবে আপনার কাছে । ",
  gift_gold: "গোল্ড গিফ্ট",
  gift_gold_description: "আপনার অ্যাপে সংরক্ষিত গোল্ড থেকে, প্রিয়জনকে গোল্ড গিফ্ট করুন মুহূর্তেই।  শুধু প্রাপকের গোল্ড কিনেন নম্বর প্রবেশ করুন, গিফ্টের পরিমাণ নির্ধারণ করুন এবং সেন্ড করে দিন আপনার গিফ্ট  অফ গোল্ড।",
  sell_gold: "গোল্ড বিক্রয়",
  sell_gold_description: "৩টি সহজ ধাপে বিক্রয় করুন আপনার গোল্ড কিনেন অ্যাপে সংরক্ষিত গোল্ড।  আপনার নির্ধারিত পরিমানের বিক্রীত অর্থ দ্রুততর জমা হয়ে যাবে আপনার ব্যাংক অথবা মোবাইল ওয়ালেট অ্যাকাউন্টে।",
  benefit: "সুবিধা",
  buy_save_comfort: "ক্রয় এবং সঞ্চয় করুন স্বাচ্ছন্দ্যে",
  buy_save_comfort_description: "গোল্ড কিনেন অ্যাপের মাধ্যমে ৫০০ টাকা থেকে শুরু করে গোল্ড ক্রয় করুন এবং আপনার ব্যক্তিগত সামর্থ্য ও সুবিধা অনুযায়ী গোল্ড সঞ্চয় বৃদ্ধি করুন। ",
  store_with_assurance: "আস্থার সাথে সঞ্চয় করুন",
  store_with_assurance_description: "গোল্ড কিনেনের সম্পূর্ণ বীমাকৃত এবং সুরক্ষিত ভল্টে, অ্যাপ থেকে ক্রয়কৃত গোল্ড সঞ্চয় করুন। আপনার ক্রয়কৃত গোল্ড সমস্ত সম্ভাব্য ঝুঁকি এবং নিরাপত্তা সম্পৃক্তি সাপেক্ষে সম্পূর্ণরূপে বীমা করা থাকবে ।",
  gain_safety: "নির্বিঘ্নে হবে লাভ",
  gain_safety_description: "আপনার সঞ্চিত গোল্ড আনবে লাভজনক ভবিষ্যৎ উপভোগ করার সুযোগ। গোল্ড প্রজন্মগতভাবে মূল্যের একটি স্থিতিশীল এবং বিশ্বস্ত সূচক হিসাবে স্বীকৃত; তাই ক্রমাগত হারে গোল্ডের মূল্য বৃদ্ধির কারণে দীর্ঘমেয়াদি সঞ্চয়ে লাভ হবার সম্ভাবনা অধিক।",
  sell_fairness: "অফিসিয়াল বাজারমূল্যে বিক্রয়",
  sell_fairness_description: "অ্যাপে প্রদর্শিত, বাজুস দ্বারা নির্ধারিত, অফিসিয়াল বাজার মূল্যে আপনার অ্যাপে ক্রয়কৃত গোল্ড বিক্রয় করুন এবং আপনার প্রাপ্য অর্থ দ্রুততর আপনার মোবাইল ওয়ালেট বা ব্যাংক অ্যাকাউন্টে রিসিভ করুন।",
  redeem_essentiality: "ইচ্ছেমতো  উত্তোলন করুন ",
  redeem_essentiality_description: "সর্বনিম্ন ১ গ্রাম থেকে শুরু করে কয়েন এবং বার রূপে গোল্ড উত্তোলন করুন। আমাদের প্রোডাক্ট সমূহ: ১ ৫ ও ১০ গ্রামের গোল্ড বার এবং ২ ও ৪ গ্রামের গোল্ড কয়েন।",

  live_life_gold_standard: "গোল্ড স্ট্যান্ডার্ডে জীবন যাপন",
 buy_gold_details: [
  "সর্বনিম্ন ৫০০ টাকা থেকে শুরু করে ২২ ক্যারেট হলমার্ক ও সার্টিফাইড গোল্ড অফিসিয়াল বাজারমূল্যে ক্রয় করুন",
  "অটো গোল্ড সেভ প্ল্যানের সাথে সর্বনিম্ন ১০০০ টাকা থেকে শুরু করে স্বয়ংক্রিয়ভাবে নিজের সুবিধামতো গোল্ড সঞ্চয় গড়ুন প্রতি মাসে"
],
  sell_gold_details: "তিনটি সহজ ধাপে আপনার গোল্ড কিনেন অ্যাপে সঞ্চিত/সংরক্ষিত গোল্ড বিক্রয় করুন",
  collect_gold_details: "গোল্ডের বার বা কয়েন (গিনি) হিসাবে আপনার সুবিধামত গোল্ড কিনেন অ্যাপে আপনার সঞ্চিত/সংরক্ষিত গোল্ড সংগ্রহ করুন",
  gift_gold_details: "আপনার গোল্ড কিনেন অ্যাকাউন্ট থেকে যে কোনো সময়, যে কোনো জায়গায় আপনার সঞ্চিত/সংরক্ষিত গোল্ড প্রিয়জনকে উপহার দিন",
  learn_more: "আরও জানুন",

  our_memberships: "আমাদের সদস্যপদ সমূহ",
  why_gold_kinen_home: "গোল্ড কিনেন থেকে গোল্ড কিনেন",

  easy: "সহজ",
  easy_description: "মাত্র কয়েক ধাপে গোল্ড ক্রয়, সঞ্চয়, উত্তোলন এবং বিক্রয় করুন। গোল্ড কিনেন অ্যাপে গোল্ডর মূল্য সর্বদা বাংলাদেশ জুয়েলার্স অ্যাসোসিয়েশন (বাজুস) দ্বারা নির্ধারিত গোল্ডের অফিসিয়াল বাজার মূল্যের অনুরূপ।  সুতরাং এখন দেশের যে কোনও জায়গা থেকে অ্যাপের মাধ্যমে গোল্ড ক্রয়, সঞ্চয় এবং উত্তোলন করুন সহজেই।",
  safe: "নিরাপদ",
  safe_description: "নিশ্চিন্তে অ্যাপ থেকে ক্রয়কৃত গোল্ড সঞ্চয় করুন গোল্ড কিনেনের সম্পূর্ণরূপে নিরাপদ এবং বীমাকৃত ভল্টে। গোল্ড কিনেনের সকল পেমেন্ট সেবা, সর্বাধিক সুরক্ষা এবং নিরাপত্তা প্রোটোকল দ্বারা সুরক্ষিত। আমাদের অঙ্গীকার গোল্ড কিনেনের সকল গ্রাহকের সঞ্চিত গোল্ড থাকবে সর্বদা নিরাপদ।",
  trusted: "বিশ্বস্ত",
  trusted_description: "গোল্ড কিনেন থেকে ক্রয়কৃত এবং উত্তোলনকৃত গোল্ড, বাংলাদেশের প্রখ্যাত প্রত্তয়নি সংস্থা, বাংলা গোল্ড দ্বারা হালমার্ক ও সার্টিফাইড, খাঁটি ২২ ক্যারাট গোল্ড। এবং গোল্ড কিনেনের অনন্য টাম্পারপ্রুফ প্যাকেজিং গ্রাহকের গোল্ডকে রাখে সুরক্ষিত এবং গড়ে তোলে বিশ্বস্ততা।",

  the_gold: "দা গোল্ড",
  convenience: "কনভিনিয়েন্স",
  gold_convenience_line1: "গোল্ড কিনেন: বাংলাদেশের ক্রমবর্ধমান ডিজিটাল অর্থনীতিকে",
  gold_convenience_line2: " নতুন ভাবে উদ্ভাবনের মাধ্যমে",
  gold_convenience_line3: "একটি দায়িত্বশীল ও বিশ্বস্ত ",
  gold_convenience_line4: "স্বর্ণালী যুগের দিকে নিয়ে যাওয়ার স্মার্ট পদক্ষেপ।",
  
  save_in_gold: "সঞ্চয় করুন গোল্ড-এ",
  save_in_gold_description: "সম্পূর্ণ হলমার্ক প্রত্যয়িত ২২ ক্যারাট গোল্ড ক্রয় করুন সর্বনিম্ন ৫০০ টাকা থেকে শুরু করে এবং অ্যাপে সংরক্ষণ করুন",
  gold_official_market_price: "অফিসিয়াল মূল্যে গোল্ড",
  gold_official_market_price_description: "বাংলাদেশ জুয়েলার্স অ্যাসোসিয়েশন (বাজুস) দ্বারা নির্ধারিত মূল্য অনুযায়ী, গোল্ড কিনেন",
  redeem: "উত্তোলন",
  physical_gold: "আসল গোল্ড উত্তোলন",
  redeem_physical_gold_description: "আপনার অ্যাপে সঞ্চিত গোল্ড উত্তোলন করুন ২ ও ৪ গ্রামের কয়েন বা ১, ৫ ও ১০ গ্রামের বার স্বরূপ",
  secure_feature: "ভবিষ্যৎ সুরক্ষার আস্থা",
  secure_feature_in_gold: "ভবিষ্যৎ সুরক্ষার আস্থা গোল্ডে",
  in_gold: "গোল্ডে",
  secure_feature_in_gold_description: "সময়ের সাথে সাথে গোল্ডর মূল্য বৃদ্ধি আপনার বিনিয়োগ এবং মূলধন লাভ নিশ্চিত করবে",

  about_us_home: "গোল্ড কিনেন সম্পর্কিত তথ্য",
  about_us_title: "দায়িত্বশীল গোল্ড সেবার নতুন যুগ",
  about_us_description: "গোল্ড কিনেন বাংলাদেশের সর্বপ্রথম গোল্ড অ্যাপ। অ্যাপটির লক্ষ্য প্রত্যেকের জন্য হলমার্ক ও সার্টিফাইড ২২ ক্যারাট গোল্ড ক্রয়, সঞ্চয় এবং উত্তোলন সহজলভ্য এবং সাশ্রয়ী করে তোলা। এখন গোল্ড ক্রয়, সঞ্চয় এবং উত্তোলন থাকবে সবার হাতের মুঠোয় । গোল্ড কিনেন অ্যাপে আপনি ২৪/৭ গোল্ড বিক্রয়ের সুবিধা লাভ করতে পারবেন। অ্যাপটির মাধ্যমে উত্তোলন করা গোল্ড ঢাকা সিটি কর্পোরেশনের অন্তুর্ভুক্ত এলাকায়  সুরক্ষিত এবং বীমাকৃত ডেলিভারির মাধ্যমে এবং দেশজুড়ে ১৫০+ নির্বাচিত পিক-আপ পয়েন্টের মাধ্যমে সরবরাহ করা হয়। ",

  step_1: "ধাপ ১: সাইন আপ করুন",
    step_1_description: "৩টি সহজ ধাপ অনুসরণ করুন এবং গোল্ড কিনেন অ্যাপে রেজিস্ট্রেশন করুন",

    step_2: "ধাপ ২: গোল্ড ক্রয় করুন ",    step_2_description: "যে কোন জায়গায়, সুবিধামতো মোবাইল ওয়ালেটের মাধ্যমে গোল্ড ক্রয় করুন মাত্র কয়েকটি ট্যাপে",

    step_3: "ধাপ ৩: গোল্ড সঞ্চয় করুন",
    step_3_description: "অ্যাপ থেকে ক্রয়কৃত গোল্ড সঞ্চয় করুন আমাদের সম্পূর্ণ বীমাকৃত ভল্টে ",


  sell_gold_home_description: "অ্যাপ থেকে ক্রয়কৃত গোল্ড, বিক্রয় করুন যখন তখন পরিমাণে কিংবা টাকায়",

  collect_gold_home_description: "অ্যাপ থেকে ক্রয়কৃত গোল্ড উত্তোলন করুন কয়েন অথবা বার স্বরূপে",

  buy_gold_home_description: "যে কোন জায়গায়, সুবিধামতো গোল্ড ক্রয় করুন মাত্র কয়েকটি ট্যাপে",

  gift_gold_home_description: "আপনার প্রিয়জনকে গোল্ড উপহার দিন অ্যাপের মাধ্যমে",
  withdraw_cash: "টাকা উত্তোলন",
  withdraw_cash_home_description: "আপনার নির্বাচিত মোবাইল ওয়ালেট অথবা ব্যাংক অ্যাকাউন্টে আপনার বিক্রয়কৃত গোল্ডের অর্থমূল্য গ্রহণ করুন",

  home_delivery: "হোম ডেলিভারি",
  home_delivery_description: "অ্যাপ থেকে ক্রয়কৃত গোল্ড উত্তোলন করে ঢাকা সিটি কর্পোরেশনের অন্তুর্ভুক্ত এলাকায় বীমাকৃত ডেলিভারির মাধ্যমে গোল্ড রিসিভ করুন আপনার দরজায়",
  pickup_delivery: "পিক-আপ পয়েন্ট",
  pickup_delivery_description: "সারা বাংলাদেশের ৬৪ জেলা জুড়ে  বিস্তৃত ১৫০+ নির্বাচিত পিক-আপ পয়েন্টের মাধ্যমে গোল্ড কয়েন ও বার উত্তোলন করুন",
  store_gold: "গোল্ড সংরক্ষণ করুন",
  store_gold_home_description: "অ্যাপ থেকে ক্রয়কৃত গোল্ড সংরক্ষণ করুন আমাদের সম্পূর্ণ বীমাকৃত ভল্টে ",

  
  home_contact_us: "যোগাযোগ করুন",
  home_contact_us_description: "যে কোনো কিছু জানতে আমাদের সাথে যোগাযোগ করুন। ",
  home_contact_your_first_name: "নামের প্রথম অংশ",
  home_contact_your_last_name: "নামের শেষ অংশ",
  home_contact_reason_for_contact: "যোগাযোগের কারণ",
  home_contact_your_website_or_company: "আপনার প্রতিষ্ঠান অথবা ওয়েবসাইট",
  home_contact_message: "বার্তা",
  home_contact_phone_number: "ফোন নম্বর",
  home_contact_email_address: "ইমেইল আইডি",
  home_contact_check_message: "এই ওয়েবসাইটকে আমার ব্যক্তিগত তথ্য সংগ্রহ করার অনুমতি দিচ্ছি।",
  submit: "সাবমিট",


  frequently_asked_questions: "সচরাচর জিজ্ঞাস্য",

  home_partner_image_1: "/image/partner/buyGoldBn.png",
  home_partner_image_2: "/image/partner/sellGoldBn.png",
  home_partner_image_3: "/image/partner/collectGoldBn.png",
  home_partner_image_4: "/image/partner/giftGoldBn.png",

  gold_kinen_title: "গোল্ড কিনেন টেকনোলজিস লিমিটেড",

  // refund
  refund_policy_header: "গোল্ড কিনেন - পণ্য বা মূল্য ফেরত ও প্রত্যাবর্তন নীতিমালা রিফান্ড এন্ড রিটার্ন পলিসি",

  // delivery protocol
  delivery_protocol_header: "গোল্ড কিনেন গ্রাহক ডেলিভারি প্রক্রিয়া এবং প্রোটোকল",


  // terms_conditions
  terms_conditions_title_description: "এই ব্যবহারকারী লাইসেন্স চুক্তি  (এই  “<b>চুক্তি </b>”) হল আপনার,  ( “<b>ব্যবহারকারী</b>”), এবং গোল্ড কিনেন টেকনোলজিস লিমিটেডের মধ্যে একটি আইনি চুক্তি যার নিবন্ধিত ঠিকানা প্লট 84, লেভেল 6, রোড 11, ব্লক ডি, বনানী।  (<b>কোম্পানি </b>বা <b>“গোল্ড কিনেন” </b>যা পরস্পর পরিবর্তনযোগ্যভাবে ব্যবহার করা হয়েছে) আপনার গোল্ড কিনেন মোবাইল অ্যাপ্লিকেশন (<b>“গোল্ড কিনেন অ্যাপ”</b>), ব্যবহার করার ক্ষেত্রে , বা এর যেকোনো অংশ, বা এর বিষয়বস্তু এবং যেকোনো পণ্য সহ এর সাথে সম্পর্কিত কিছু, যেমন, 22 ক্যারেট গোল্ড (<b>“পণ্য”</b>) বা পরিষেবাগুলি  (অর্থাৎ, (i) গোল্ড ক্রয়, (ii) গোল্ড বিক্রয়, (iii) গোল্ড উত্তোলন এবং (iv) গিফ্ট গোল্ড) আরও গোল্ড কিনেন অ্যাপের (<b>“পরিষেবা”</b>)পণ্যের বিশদ বর্ণনা এই চুক্তির <b>তফসিল A </b>তে প্রদত্ত",

  terms_conditions_agree_description: "এই চুক্তির শেষে  “স্বীকার করুন” / “আমি সম্মত” বাটনে ক্লিক করার মাধ্যমে, আপনি স্বীকার করছেন যে আপনি এই চুক্তি এবং শর্তাবলী  (“পরিষেবার শর্তাবলী” অথবা “শর্তাবলী” যেমন পরস্পর পরিবর্তনযোগ্যভাবে ব্যবহৃত হয়) পড়েছেন, সম্পূর্ণ বুঝেছেন,  এবং যা এখানে উল্লেখ করা হয়েছে এতে সম্মত এবং আবদ্ধ হবেন:",

  refund_gold: "গোল্ড ফেরত",

  terms_service_a: "তফসিল A: পরিষেবা",
  terms_service_a_description: "The Company shall provide, among others, the following Services through the Gold Kinen App:",

  terms_service_b: "শিডিউল বি: পেমেন্ট পদ্ধতি",
  terms_service_b_description: "The payment by the Users to the Company through the Gold Kinen App shall be in the following manner:",

  terms_service_c: "সিডিউল সি: ডেলিভারি মেকানিজম",

  privacy_policy_description: "<p>গোল্ড কিনেন টেকনোলজিস লিমিটেড দ্বারা পরিচালিত গোল্ড কিনেনে ('অ্যাপ') স্বাগতম। আমরা আপনার গোপনীয়তাকে সম্মান করি এবং আপনার ব্যক্তিগত তথ্য রক্ষা করতে তৎপর । আরও জানতে, অনুগ্রহ করে এই গোপনীয়তা নীতিমালাটি পড়ুন।</p><br></br><p>এই গোপনীয়তা নীতিমালা ব্যাখ্যা করে, কিভাবে আমরা আপনার ব্যক্তিগত তথ্য সংগ্রহ করি, ব্যবহার করি এবং (কিছু শর্তের অধীনে) প্রকাশ করি। এই গোপনীয়তা নীতিমালাতে আপনার ব্যক্তিগত তথ্য সুরক্ষিত করার জন্য আমরা যে পদক্ষেপ নিয়েছি তাও ব্যাখ্যা করে। এবং, এই গোপনীয়তা নীতিমালা আপনার ব্যক্তিগত তথ্য সংগ্রহ, ব্যবহার এবং প্রকাশ সংক্রান্ত তথ্য এবং কাম্য বিকল্প পদক্ষেপ ব্যাখ্যা করে। অ্যাপটিতে সরাসরি গিয়ে বা অন্য অ্যাপের মাধ্যমে, আপনি এই নীতিমালাতে বর্ণিত অনুশীলনগুলি সমর্থন করেন। </p><br></br>",

  how_it_works_img: "/image/howItWorks/howItWorksBn2.png",

  termsConditionDoc:'https://drive.google.com/file/d/1hL9RxdHhGJAT5DCgOGRvn9G72en-vnJb/preview',
  zakatRules:'https://drive.google.com/file/d/1gDVWYyAPgx-FuBybAIQXWqzae5IL2NRM/preview',
  autoSaveTermsCondition:'https://drive.google.com/file/d/1T1eGDaFB1L3cuFJyn5V1Pt1aslFCjAFY/preview',
  address:'রেজিস্ট্রেশনকৃত ঠিকানা: হাউজ-৮৪, লেভেল-৬, রোড-11,  ব্লক-ডি, বনানী, ঢাকা-১২১৩',
  schedule_of_charges:'চার্জসমূহ',
  service_charges:'সার্ভিস চার্জসমূহ',
  rate:'রেট',
  delivery_charges:'হোম ডেলিভারি চার্জসমূহ',
  pickup_charges:'পিক-আপ পয়েন্ট চার্জসমূহ',
  inside_Dhaka:'ঢাকার ভিতর',
  outside_Dhaka:'ঢাকার বাহির',
  inside_Dhaka_charge:'৳ ১৭৫',
  outside_Dhaka_charge:'৳ ৩৪৫',
  buy:'ক্রয়',
  collect:'উত্তোলন',
  gift:'গিফ্ট',
  refund_app:'বিক্রয়/রিফান্ড (অ্যাপের মাধ্যমে)',
  refund_show_room:'বিক্রয়/রিফান্ড (শোরুমের মাধ্যমে)',
  buy_service_charge:'০%',
  collect_service_charge:'২%',
  refund_service_charge_app:'৬%',
  refund_service_charge_showroom:'১৭%',
  gift_service_charge:'০%',
  two_gram_coin_delivery_charge:'২ গ্রাম কয়েন',
  four_gram_coin_delivery_charge:'৪ গ্রাম কয়েন',
  one_gram_bar_delivery_charge:'১ গ্রাম বার',
  five_gram_bar_delivery_charge:'৫ গ্রাম বার',
  ten_gram_bar_delivery_charge:'১০ গ্রাম বার',
  two_gram_coin_delivery_charge_rate:'৳ ১৫০',
  four_gram_coin_delivery_charge_rate:'৳ ২০০',
  one_gram_bar_delivery_charge_rate:'৳ ১৫০',
  five_gram_bar_delivery_charge_rate:'৳ ৩০০',
  ten_gram_bar_delivery_charge_rate:'৳ ৫০০',

  Logo:'/image/navbar/banglaGKLogo.png',

  //news section

  gold_kinen_news:'ফিচার্ড নিউজ',
  email:'ইমেইল',
  yearly:'বাৎসরিক',
  Fiveyear:'৫ বছর মেয়াদী',
  Tenyear:'১০ বছর মেয়াদী',
  chartHeader:'সময়ের সাথে স্বর্ণের মূল্য (২২ ক্যারেট, বাজুস কর্তৃক নির্ধারিত মূল্য টাকা/ভরি )',
  pickupPoint:'https://drive.google.com/file/d/1rrlQruKQRV8UcIi27LmxV_K7orHMw63C/preview',
  pickup:'পিকআপ পয়েন্ট সমূহ'
}

